/**
 * @generated SignedSource<<3732ec9e4e0a55bb3c7b36210917bc39>>
 * @relayHash 19081691cac2c634716f82092efd5e14
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3d5dc74f8943db901b65da9952c21aedcb442dbab7bde8fc78fddd85434811f3

import type { ConcreteRequest, Query } from 'relay-runtime';
export type CustomHeaderFooterQuery$variables = {
  spaceKey?: string | null | undefined;
};
export type CustomHeaderFooterQuery$data = {
  readonly space: {
    readonly id: string | null | undefined;
    readonly settings: {
      readonly customHeaderAndFooter: {
        readonly footer: {
          readonly css: string;
          readonly html: string;
          readonly js: ReadonlyArray<string | null | undefined>;
          readonly spaUnfriendlyMacros: ReadonlyArray<{
            readonly name: string | null | undefined;
          }>;
        };
        readonly header: {
          readonly css: string;
          readonly html: string;
          readonly js: ReadonlyArray<string | null | undefined>;
          readonly spaUnfriendlyMacros: ReadonlyArray<{
            readonly name: string | null | undefined;
          }>;
        };
      };
    } | null | undefined;
  } | null | undefined;
};
export type CustomHeaderFooterQuery = {
  response: CustomHeaderFooterQuery$data;
  variables: CustomHeaderFooterQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "kind": "ScalarField",
    "name": "html"
  },
  {
    "kind": "ScalarField",
    "name": "js"
  },
  {
    "kind": "ScalarField",
    "name": "css"
  },
  {
    "concreteType": "SpaUnfriendlyMacro",
    "kind": "LinkedField",
    "name": "spaUnfriendlyMacros",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "name"
      }
    ]
  }
],
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "concreteType": "SpaceSettings",
        "kind": "LinkedField",
        "name": "settings",
        "plural": false,
        "selections": [
          {
            "concreteType": "SpaceSettingsMetadata",
            "kind": "LinkedField",
            "name": "customHeaderAndFooter",
            "plural": false,
            "selections": [
              {
                "concreteType": "HtmlMeta",
                "kind": "LinkedField",
                "name": "header",
                "plural": false,
                "selections": (v1/*: any*/)
              },
              {
                "concreteType": "HtmlMeta",
                "kind": "LinkedField",
                "name": "footer",
                "plural": false,
                "selections": (v1/*: any*/)
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "CustomHeaderFooterQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CustomHeaderFooterQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "19081691cac2c634716f82092efd5e14",
    "id": "3d5dc74f8943db901b65da9952c21aedcb442dbab7bde8fc78fddd85434811f3",
    "metadata": {},
    "name": "CustomHeaderFooterQuery",
    "operationKind": "query",
    "text": "query CustomHeaderFooterQuery($spaceKey:String){space(key:$spaceKey){id,settings{customHeaderAndFooter{header{html,js,css,spaUnfriendlyMacros{name}},footer{html,js,css,spaUnfriendlyMacros{name}}}}}}"
  }
};
})();

(node as any).hash = "deed3f087b4973bd7d276b1389cfb125";

export default node;
